"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRouter = exports.RouterContext = void 0;
const React = __importStar(require("react"));
const router_1 = require("./router");
/**
 * Utility functions to interact with the URL + information about the vanity domain implementation, if applies.
 *
 * @category Contexts
 */
exports.RouterContext = React.createContext({
    context: null,
    location: global.location,
    getPath: router_1.getPath,
    getPreviousRoutesSection: () => null,
    push: (url) => { var _a; return (_a = global.history) === null || _a === void 0 ? void 0 : _a.pushState({}, '', url); },
    goBack: () => global.history.back(),
    setDocumentMeta: () => { }
});
exports.RouterContext.displayName = 'RouterContext';
/**
 * @ignore
 */
function withRouter(Component) {
    return function RouterComponent(props) {
        return (React.createElement(exports.RouterContext.Consumer, null, (router) => React.createElement(Component, Object.assign({}, props, { router: router }))));
    };
}
exports.withRouter = withRouter;
